import api from '@/utils/api';


export const fetchApplication = async () => (await api.get(`application/`));
export const getAuthToken = async (payload) => (await api.post('auth/token/', payload));
export const requestPasswordReset = async (payload) => (await api.post('auth/request-password-reset/', payload));
export const fetchPasswordReset = async (uuid) => (await api.get(`password-resets/${uuid}/`));
export const confirmPasswordReset = async (uuid, payload) => (await api.patch(`password-resets/${uuid}/`, payload));
export const getAuthTokenByPin = async (confirmUUID, pin) => (await api.post(
  `login-requests/${confirmUUID}/token/`,
  { pin },
));
export const registerUser = async (payload) => (await api.post('auth/register/', payload));
export const authenticateRegistrationWithPin = async (payload) => (
  await api.post('auth/authenticate-with-pin/', payload)
);
export const resetRegistrationPin = async (payload) => (await api.post('auth/reset-pin/', payload));
export const createSession = async () => (await api.post('auth/session/'));
export const confirmEmailChange = async (uuid) => (
  await api.patch(`email-change-requests/${uuid}/confirm/`)
);

export const users = {
  fetch: async () => {
    return await api.get('users/current/');
  },

  // Zonder e-mailadres schrijft de backend de ingelogde gebruiker zelf in.
  registerNewsletter: async (email) => {
    return await api.patch('users/register-news-letter/', email ? { email } : {});
  },

  delete: async ({ email }) => {
    return await api.delete('users/current/',
      {
        email
      },
    );
  },

  update: async ({ first_name, infix, last_name, zip, gender, birth_date, language }) => {
    return await api.patch('users/profile/', {
      first_name,
      infix,
      last_name,
      zip,
      gender,
      birth_date,
      language,
    });
  },

  updatePassword: async ({ old_password, new_password1, new_password2 }) => {
    return await api.patch('users/password/',
      {
        old_password,
        new_password1,
        new_password2
      },
    );
  },

  updateEmail: async ({ email, news_letter }) => {
    return await api.post('email-change-requests/',
      {
        email,
        news_letter
      },
    );
  },
  updateProfilePicture: async (formData) => {
    return await api.patch(
      'users/profile-picture/',
      formData,
      { 'Content-Type': 'multipart/form-data' },
    )
  },
  updateAgreements: async (formData) => {
    const { acceptConditions, acceptPrivacyStatement } = formData;
    return await api.patch(
      'users/agreement/', {
        accept_conditions: acceptConditions,
        accept_privacy_statement: acceptPrivacyStatement,
      },
    )
  },
};


export const registrationTemplates = {
  get: async (templateSlug) => {
    return await api.get(`registration-templates/${templateSlug}/`);
  },
  submit: async (templateSlug, formData) => {
    return await api.post(`registration-templates/${templateSlug}/submit/`, { form_data: formData });
  },
}
// Without an organisation is for staff only;
export const createCliLoginRequest = async (
  codeChallenge,
  organisationId,
  lifetimeMinutes,
  withoutOrganisation = false,
) => (
  await api.post('cli-login-requests/', {
    code_challenge: codeChallenge,
    ...(withoutOrganisation ? { without_organisation: true } : {}),
    ...(!withoutOrganisation && organisationId ? { organisation_id: organisationId } : {}),
    ...(lifetimeMinutes ? { lifetime_minutes: lifetimeMinutes } : {}),
  })
);

export const cliTokens = {
  list: async () => await api.get('cli-tokens/'),
  revoke: async (id) => await api.delete(`cli-tokens/${id}/`),
};
